export const AUTH = {
  LOGIN: '/',
  FORGET_PASSWORD: '/forgotPassword',
  RESET_PASSWORD: '/resetPassword',
  CONFIRM_RESET: '/confirmReset',
  ADMIN: '/superuser',
};
